// Флаги кабинета: какое меню показать и видел ли человек короткое обучение по меню.
// Только чистые функции, без axios и http: их проверяют тесты в Node.
// Запросы к серверу лежат в api/uiFlags.js.

export const SHELL_OLD = "old";
export const SHELL_V3 = "v3";

// Прежние версии запоминали выбор меню в localStorage: uprasti:navV3:{userId}.
// Выбора больше нет, при выходе эти записи стираются.
export const NAV_V3_CACHE_PREFIX = "uprasti:navV3:";

const NAV_V3_SOURCES = ["kill", "default"];

// localStorage может быть недоступен (приватный режим, запрет cookie) или бросать ошибку.
function getStorage(storage) {
  if (storage !== undefined) return storage;
  try {
    return typeof localStorage !== "undefined" ? localStorage : null;
  } catch (_error) {
    return null;
  }
}

// При выходе стираем выбор меню всех людей в этом браузере: функция выхода не знает
// точно, кто вошёл (профиль в redux может остаться от прошлого человека).
export function clearAllNavV3Caches(storage) {
  try {
    const target = getStorage(storage);
    if (!target) return;
    const keys = [];
    const length = Number(target.length) || 0;
    for (let index = 0; index < length; index += 1) {
      const key = target.key(index);
      if (typeof key === "string" && key.startsWith(NAV_V3_CACHE_PREFIX)) keys.push(key);
    }
    keys.forEach((key) => target.removeItem(key));
  } catch (_error) {
    // Без хранилища стирать нечего.
  }
}

// С 22.10.2026 новое меню у всех, выбрать старое человек не может. Старое
// показывается только по общему выключателю: его видит опрос nav-kill (killed)
// или сервер отвечает navV3: false. До ответа сервера сразу новое меню.
export function decideShell({ killed, server } = {}) {
  if (killed === true || server === false) return SHELL_OLD;
  return SHELL_V3;
}

// Ответ GET /api/ui/flags. Всё, кроме 200 с JSON, считаем ошибкой: например, index.html,
// который сервер отдаёт на неизвестный адрес.
export function parseNavFlagsAnswer(status, data) {
  if (status !== 200 || !data || typeof data !== "object") return null;
  if (typeof data.navV3 !== "boolean") return null;
  return {
    navV3: data.navV3,
    canSeeReviews: data.canSeeReviews === true,
    source: NAV_V3_SOURCES.includes(data.source) ? data.source : null,
    navTourSeen: data.navTourSeen === true,
  };
}

// Ответ GET /api/ui/nav-kill: true или false, null при любой ошибке.
export function parseNavKillAnswer(status, data) {
  if (status !== 200 || !data || typeof data !== "object") return null;
  return typeof data.off === "boolean" ? data.off : null;
}
